import { useLanguage } from "@/context/LanguageContext";
import { Link } from "@/i18n/LocalizedLink";
import { Seo } from "@/components/Seo";
import { Home, ArrowRight } from "lucide-react";
import { CallButton, WhatsAppButton } from "@/components/ActionButtons";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <>
      <Seo title={t("Page Not Found | Jitendra Singh Tour Operator Service")} description={t("The page you were looking for could not be found.")} noindex />
      <section className="min-h-[60vh] flex items-center justify-center bg-[#071426] px-4 py-20">
        <div className="text-center max-w-lg" data-testid="not-found-page">
          <p className="text-6xl font-extrabold text-amber-400">404</p>
          <h1 className="mt-4 text-2xl sm:text-3xl font-extrabold text-white">{t("This page couldn't be found")}</h1>
          <p className="mt-3 text-slate-300">{t("The link may be broken or the page may have moved. Let's get you back on the road.")}</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="notfound-home-link" className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-5 py-3 font-bold text-slate-950 hover:bg-amber-400">
              <Home className="h-4 w-4" /> {t("Go to homepage")}
            </Link>
            <Link to="/service-areas/" data-testid="notfound-areas-link" className="inline-flex items-center gap-2 rounded-full border border-slate-600 px-5 py-3 font-semibold text-slate-100 hover:bg-white/5">
              {t("Service areas")} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <CallButton className="bg-sky-600 px-5 py-2.5 text-white hover:bg-sky-700" testId="notfound-call-button" label={t("Call Now")} />
            <WhatsAppButton className="bg-emerald-600 px-5 py-2.5 text-white hover:bg-emerald-700" testId="notfound-whatsapp-button" />
          </div>
        </div>
      </section>
    </>
  );
}
